import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getUniqueOutboundPhoneNumbers = async () => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    query: graphql(`
      query UniqueOutboundPhoneNumbers {
        uniqueOutboundPhoneNumbers
      }
    `),
  });

  return response.data.uniqueOutboundPhoneNumbers;
};
